module.exports = __webpack_public_path__ + "sunsemweb/img/hbanner.35989814.png";